export default __webpack_public_path__ + "static/latitude-low-rate-mastercard-horizontal-2468579d690cc0aca21182e128edb928.png";